export default "__VITE_ASSET__CuYw49z___"